// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"c97ca336","139":"3e0791d0","213":"632fa5f0","239":"9180e550","353":"f59ce306","455":"11c7312c","592":"cc6c97de","822":"fc9f237f","938":"f6f08b0c"}[chunkId] + ".chunk.js";
};